const PaymentAction = {
    CONFIG_INFO: "ConfigInfo",
    PAYMENT_INFO: "PaymentInfo",
    UPDATE_CARD: "UpdateCard",

    VALIDATE_TRIAL: "ValidateTrial"
}

export default PaymentAction;